import { ReactComponent as Endchat } from '../../../../assets/EndChat.svg';
import { ReactComponent as MinimizeIcon } from '../../../../assets/Minimize.svg';
import styled from '../../../../lib/theme';

interface IMainHeaderProps {
  backgroundColor?: string;
}

export const MainHeader = styled('div')<IMainHeaderProps>`
  background-color: ${(props: IMainHeaderProps) => (props.backgroundColor ? props.backgroundColor : 'grey')};
  padding: 15px 18px;
  display: flex;
  justify-content: space-between;
`;

interface IMainHeaderTitleProps {
  logoProvided?: boolean;
}

export const MainHeaderTitle = styled('div')<IMainHeaderTitleProps>`
  color: ${(props) => props.theme.primaryAccentTextColor};
  font-weight: bold;
  font-size: 16px;
  width: fit-content;
  ${(props: IMainHeaderTitleProps) => (props.logoProvided ? 'margin-left: 12px;' : '')};
  line-height: 32px;
`;

export const LogoContainer = styled('div')`
  height: 32px;

  img {
    display: block;
    height: 100%;
  }
`;

export const StyledEndChat = styled(Endchat)`
  margin-right: -5px;
  margin-top: 2px;
  ${({ theme }) => `
    * {
      fill: ${theme.primaryAccentTextColor};
    }
  `}
`;

export const StyledMinimize = styled(MinimizeIcon)`
  margin-right: 5px;
  ${({ theme }) => `
    * {
      stroke: ${theme.primaryAccentTextColor};
      fill: ${theme.primaryAccentTextColor};
    }
  `}
`;
